import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<app-update></app-update><router-outlet></router-outlet>'
})
export class RootComponent {}
